import styled from "styled-components";

export const AdvancedTabsSingleEditorContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 96px;
`;
